"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../elements/Flex"));

var _md = require("react-icons/md");

var _styles = require("../styles");

var _Caption = _interopRequireDefault(require("../elements/Caption"));

var _dotUtils = require("dot-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function WidgetStatsTease(_ref) {
  var views = _ref.views,
      engagement = _ref.engagement,
      props = _objectWithoutProperties(_ref, ["views", "engagement"]);

  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], _extends({
    itemGap: _styles.baseSpacing,
    alignItems: 'center'
  }, props), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: 'center',
    itemGap: 5
  }, /*#__PURE__*/_react["default"].createElement(_md.MdRemoveRedEye, null), /*#__PURE__*/_react["default"].createElement(_Caption["default"], {
    fontSize: _styles.fontSizes.body
  }, (0, _dotUtils.viewsDisplay)(views || 0))), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: 'center',
    itemGap: 5
  }, /*#__PURE__*/_react["default"].createElement(_md.MdTimer, null), /*#__PURE__*/_react["default"].createElement(_Caption["default"], {
    fontSize: _styles.fontSizes.body
  }, (0, _dotUtils.engagementDisplay)(engagement || 0))));
}

var _default = WidgetStatsTease;
exports["default"] = _default;